import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store'
//import iView from 'iview' /*组件可以按需引入*/
import 'iview/dist/styles/iview.css'
//import Swiper from 'swiper' /*组件可以按需引入*/
//import 'swiper/dist/css/swiper.css'
//import 'lib-flexible'
/*设计稿量到多少,项目中就直接写多少就好了*/
import './styles/common.less'
import './styles/login.css'
import './styles/base.css'
import './styles/swiprun.css'
import './styles/content.css'
import './styles/contentcard.css'
/*media query 查询的样式属性*/
import VueLazyLoad from 'vue-lazyload' 
/*图片懒加载*/


Vue.config.productionTip = false
axios.defaults.headers.post['Content-Type'] = 'application/json'
Vue.use(VueLazyLoad,{
    error:'./assets/bannerone.png',
    loading:'./assets/bannerone.png'
})
//Vue.use(iView) /*组件若是按需引入,则就按需用*/

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js